<template>
  <div>
    <span v-if="data.column.field === 'insertedTime'">
      <div class="d-flex justify-content-between text-align-left">
        <span>
          {{ data.formattedRow.insertedTime }}
        </span>
        <span
          v-if="data.row.statusId === 3"
          class="d-flex"
        >
          <b-button
            v-b-modal.approve-reject-ad-modal
            variant="link"
            class="p-0"
            @click="modalConfirm(data.row, type = 1)"
          >
            <GjIcon
              name="Check"
              class="text-success"
            />
          </b-button>
          <b-button
            v-b-modal.approve-reject-ad-modal
            variant="link"
            class="p-0"
            @click="modalConfirm(data.row, type = 2)"
          >
            <GjIcon
              name="Close"
              class="text-danger"
            />
          </b-button>
        </span>
      </div>
    </span>

    <span
      v-else-if="data.column.field === 'preview'"
      class="d-flex justify-content-around text-primary"
    >
      <b-button
        variant="link"
        size="sm"
        @click="previewAd(data.row.id)"
      >
        <GjIcon
          name="Show"
        />
        {{ $tk('ClientPortal.Admin.PreviewAd') }}
      </b-button>
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    previewAd: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const modalConfirm = (data, type) => store.commit('SET_AD_TO_APPROVE_REJECT', { data, type })

    return {
      modalConfirm,
    }
  },
}
</script>
